import styles from "./AboutUsPage.module.css";
import PrimarySection from "../components/UI/PrimarySection";
import Heading from "../components/UI/Heading";
import CtaLink from "../components/CtaLink/CtaLink";
import aboutBackgroundImg from "../assets/images/about-bg.png";
import Details from "../components/About/Details";
import Info from "../components/About/Info";
import Address from "../components/Home/Address";
import Updates from "../components/Home/Updates";
import Carousel from "../components/Carousel/Carousel";

const aboutUsData = [
  {
    id: 1,
    img: require("../assets/images/about-slide-1.png"),
    alt: "",
  },
  {
    id: 2,
    img: require("../assets/images/about-slide-2.png"),
    alt: "",
  },
  {
    id: 3,
    img: require("../assets/images/about-slide-3.png"),
    alt: "",
  },
  {
    id: 4,
    img: require("../assets/images/about-slide-4.png"),
    alt: "",
  },
];

const AboutUsPage = () => {
  return (
    <>
      <PrimarySection
        className={styles.section}
        backgroundImage={aboutBackgroundImg}
      >
        <Heading className={styles.heading} text1="About" text2="Us" />
      </PrimarySection>
      <CtaLink />
      <Details />
      <Carousel className={styles.carousel} data={aboutUsData} />
      <Info />
      <Address />
      <Updates />
    </>
  );
};

export default AboutUsPage;
